import React, { Component } from 'react';

import ListaDeCampos from './ListaDeCampos';
import api from '@api';
import navigate from '@/utils/navigate';

export default class AtestarCampoDeEstagio extends Component {
	constructor() {
		super();

		this.state = {
			listaDeCampos: [],
			listaDeCursos: [],

			dados: {
				curso: { id: '' },
				responsavel: {
					nome: '',
					siape: '',
					formacao: '',
				},
				vigencia: {
					inicio: '',
					fim: '',
				},
				ativo: true,
				observacoes: '',
			},
		};

		this.carregaListaDeCampos = this.carregaListaDeCampos.bind(this);
		this.carregaListaDeCursos = this.carregaListaDeCursos.bind(this);

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidMount() {
		this.carregaListaDeCampos();
		this.carregaListaDeCursos();
	}

	carregaListaDeCampos() {
		api.cursos.ListaTodos()
			.then((listaDeCursos) => {
				this.setState({ listaDeCursos });
			});
	}

	carregaListaDeCursos() {
		api.camposDeEstagio.ListaTodos()
			.then((listaDeCampos) => {
				this.setState({ listaDeCampos });
			});
	}

	atestarCampoDeEstagio(dados) {
		api.atestesDeCampo.Novo(dados)
			.then(() => {
				navigate('/');
			})
			.catch((erro) => {
				console.log(erro);
			});
	}

	onSubmit(e) {
		e.preventDefault();

		const { dados } = this.state;
		this.atestarCampoDeEstagio(dados);
	}

	onChange(e) {
		const { name, value } = e.target;

		this.setState(prevState => ({
			dados: {
				...prevState.dados,
				[name]: value,
			},
		}));
	}

	onChangeSubAttribute(attribute, e) {
		const { name, value } = e.target;

		const target = {
			name: attribute,
			value: {
				...this.state.dados[attribute],
				[name]: value,
			},
		};

		this.onChange({ target });
	}

	render() {
		const { dados, listaDeCampos, listaDeCursos } = this.state;

		if (dados.local_de_estagio === undefined) {
			return (
				<ListaDeCampos
					listaDeCampos={listaDeCampos}
					onSelect={(local_de_estagio) => this.setState(prevState => ({ dados: { ...prevState.dados, local_de_estagio } }))}
				/>
			);
		}

		const { curso, responsavel, vigencia, observacoes } = dados;

		return (
			<form className="container pb-3" onSubmit={this.onSubmit}>
				<h5 className="my-2 text-dark">
					<strong>Cadastro de Ateste de Campo de Estágio</strong>
				</h5>

				<h5>Responsável pelo Ateste</h5>

				<div className="row">
					<div className="mb-3 col-lg-6 col-md-9 col-sm-12 col-12">
						<label className="form-label" htmlFor="nome">Nome</label>
						<input className="form-control" id="nome" name="nome" type="text" value={responsavel.nome} onChange={(e) => this.onChangeSubAttribute('responsavel', e)} required minLength="2" maxLength="80" pattern={'^.{2,80}$'} />
					</div>
					<div className="mb-3 col-lg-2 col-md-9 col-sm-12 col-12">
						<label className="form-label" htmlFor="siape">Siape</label>
						<input className="form-control" id="siape" name="siape" type="text" value={responsavel.siape} onChange={(e) => this.onChangeSubAttribute('responsavel', e)} required minLength="2" maxLength="80" pattern={'^.{2,80}$'} />
					</div>
					<div className="mb-3 col-lg-4 col-md-9 col-sm-12 col-12">
						<label className="form-label" htmlFor="formacao">Formação</label>
						<input className="form-control" id="formacao" name="formacao" type="text" value={responsavel.formacao} onChange={(e) => this.onChangeSubAttribute('responsavel', e)} required minLength="2" maxLength="80" pattern={'^.{2,80}$'} />
					</div>
				</div>

				<div className="row">
					<div className="mb-3 col-lg-6 col-md-9 col-sm-12 col-12">
						<label className="form-label" htmlFor="curso">Curso</label>
						<select className="form-control" id="curso" name="id" value={curso.id} onChange={(e) => this.onChangeSubAttribute('curso', e)} required>
							<option value=''>Selecione um curso</option>
							{
								listaDeCursos.map(curso =>
									<option key={curso.id} value={curso.id}>{curso.nome}</option>
								)
							}
						</select>
					</div>

					<div className="mb-3 col-lg-3 col-md-9 col-sm-12 col-12">
						<label className="form-label" htmlFor="inicio">Inicio</label>
						<input className="form-control" id="inicio" name="inicio" type="date" value={vigencia.inicio} onChange={(e) => this.onChangeSubAttribute('vigencia', e)} required minLength="2" maxLength="80" pattern={'^.{2,80}$'} />
					</div>
					<div className="mb-3 col-lg-3 col-md-9 col-sm-12 col-12">
						<label className="form-label" htmlFor="fim">Fim</label>
						<input className="form-control" id="fim" name="fim" type="date" value={vigencia.fim} onChange={(e) => this.onChangeSubAttribute('vigencia', e)} required minLength="2" maxLength="80" pattern={'^.{2,80}$'} />
					</div>
				</div>

				<div className="row">
					<div className="mb-3 col-12">
						<label className="form-label" htmlFor="observacoes">Observações</label>
						<textarea className="form-control" id="observacoes" name="observacoes" onChange={this.onChange}>{observacoes}</textarea>
					</div>
				</div>

				<div className="d-flex">
					<input className="ms-auto btn btn-success px-4" type="submit" value="Cadastrar" />
				</div>
			</form>
		);
	}
}
